<template>
    <div>
        <router-link to="/BITool/resultchain">
            <base-button
                @click="openModal()"
                :type="currentRoute=='resultchain'?'info':'grey'"
                class="addIndicatorBtn"
                >Result Chain</base-button
            ></router-link
        >
        <router-link to="/BITool/indicatorForm">
            <base-button
                @click="openModal()"
                :type="currentRoute=='master'?'info':'grey'"
                class="addIndicatorBtn"
                >Indicator Master</base-button
            ></router-link
        >
        <!-- <router-link to="/logmonitoring/monitoringForm"> -->
        <router-link to="/BITool/addmonitoringForm">
            <base-button  :type="currentRoute=='monitoring'?'info':'gray'" class="addIndicatorBtn"
                >Indicator Monitoring</base-button
            ></router-link
        >
        <router-link to="/BITool/reports">
            <base-button  :type="currentRoute=='reports'?'info':'gray'" class="addIndicatorBtn"
                >Reports</base-button
            ></router-link
        >
        <router-link to="/BITool/chart">
            <base-button  :type="currentRoute=='chart'?'info':'gray'" class="addIndicatorBtn"
                >Chart</base-button
            ></router-link
        >
        <router-view></router-view>
    </div>
</template>
<style></style>
<script>
import IndicatorForm from "@/components/BITool/IndicatorForm";
import MonitoringForm from "@/components/BITool/MonitoringForm";
export default {
    components: {
        IndicatorForm,
        MonitoringForm,
    },
    data() {
        return {
            showMonitoringForm: false,
            currentRoute:"master"
        };
    },
    mounted(){
        if(this.$route.path=="/BITool/indicatorForm"){
                this.currentRoute="master"
            }
            else if(this.$route.path=="/BITool/addmonitoringForm"){
                this.currentRoute="monitoring"
            }
            else if(this.$route.path=="/BITool/reports"){
                this.currentRoute="reports"
            }
            else if(this.$route.path=="/BITool/resultchain"){
                this.currentRoute="resultchain"
            }
            else if(this.$route.path=="/BITool/chart"){
                this.currentRoute="chart"
            }
    },
    watch:{
        "$route.path":function(val){
            // console.log(val);
            if(val=="/BITool/indicatorForm"){
                this.currentRoute="master"
            }
            else if(val=="/BITool/addmonitoringForm"){
                this.currentRoute="monitoring"
            }
            else if(val=="/BITool/reports"){
                this.currentRoute="reports"
            } else if(this.$route.path=="/BITool/resultchain"){
                this.currentRoute="resultchain"
            }else if(this.$route.path=="/BITool/chart"){
                this.currentRoute="chart"
            }
        }
    }
};
</script>
